export default {
  "duplicate": "Duplicate",
  "save": "Save",
  "discard": "Discard",
  "additionalInfo": "Additional info",
  "loading": "Loading...",
};
